export const CustomerContactTypes = ['Z', 'Y', 'X', 'V', 'U', 'T', 'S', 'R', 'Q', 'N'];
//export const InvoiceContactType = 'I';
